import { useState } from "react";
import { CustomAbsolutePositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Divider, Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "../text/CustomText";
import CustomIcon from "../image/CustomIcon";
import SecondaryButton from "../button/SecondaryButton";
import Translate from "../../translate/Translate";
import PrimaryButton from "../button/PrimaryButton";
import { Theme } from "../../Theme";

export default function DateFilterDropdownMenu({
    initValue,
    setValue,
    values,
    onClose,
    setIsCalendarOpen,
    setCustomValue,
    openedLeftSide,
}) {
    const [currentValue, setCurrentValue] = useState(initValue);

    const applyValue = () => {
        if (currentValue === "From - To") {
            setCustomValue();
        } else {
            setValue(currentValue);
        }
        onClose();
    };

    const handleChange = (clickedValue) => {
        if (clickedValue === "From - To") {
            setIsCalendarOpen(true);
        } else {
            setIsCalendarOpen(false);
        }
        setCurrentValue(clickedValue);
    };

    return (
        <CustomAbsolutePositionDropdownWrapper openedLeftSide={openedLeftSide} width={"232px"}>
            <SizedBox height={"12px"} />
            {values.map((value) => (
                <Row
                    key={value}
                    justifyContent={"space-between"}
                    padding={"10px 20px"}
                    cursor={"pointer"}
                    onClick={() => handleChange(value)}
                >
                    <C3Text fontColor={Theme.color.zinc850}>{value}</C3Text>

                    {currentValue === value && <CustomIcon iconName={"checked_active"} size={"15.5px"} />}
                </Row>
            ))}
            <Divider />
            <Row justifyContent={"flex-end"} padding={"12px"}>
                <SecondaryButton text={Translate("common.cancel")} onClick={onClose} />
                <SizedBox width={"7px"} />
                <PrimaryButton text={Translate("common.apply")} onClick={applyValue} />
            </Row>
        </CustomAbsolutePositionDropdownWrapper>
    );
}
